// Copy for the home-page « experience »: the opening banner
// (Hero/HeroSection.jsx), the 4-photo walkthrough (HowItWorks.jsx) and the
// playable demo (GameDemo.jsx).
// Translation of fr/experience.js — exactly the same keys.
export default {
  /* ----------------------------------------------------- HeroSection */

  'hero.badge': '🤫 You already know. They don’t.',

  // The title runs over two lines, the second one in a gradient.
  'hero.titre.ligne1': 'Let them discover',
  'hero.titre.ligne2': 'THE BIG SECRET',

  // Sentence split around the <strong> and the <br />: the bold clears up the
  // misunderstanding (« it isn’t YOU discovering the sex »).
  'hero.accroche.fort': 'You know your baby’s sex. Your loved ones don’t.',
  'hero.accroche.texte':
    'This game makes them guess it: two teams, 11 “mum or dad?” questions, and a last puzzle piece to scratch that announces it to everyone at once.',
  'hero.accroche.objet': '📦 A real cardboard game box, delivered to your door.',

  'hero.cta.offre': '✨ Discover our packs',
  'hero.cta.enSavoirPlus': '↓ Find out more',

  'hero.atout.pieces': '12 pieces, not 1000',
  'hero.atout.joueurs': 'From 2 to 10 players',
  'hero.atout.duree': '20 minutes',

  'hero.imageAlt':
    'Joyful Reveal — Mirum Games gender reveal game: the two-bear jigsaw, ‘baby boy’ or ‘baby girl’',
  'hero.scroll': 'Scroll to discover',

  /* ------------------------------------------------------ HowItWorks */

  'how.badge': 'The scenario',
  'how.titre': 'Invite them to dinner. Say nothing.',
  'how.description':
    'To them, it’s just dinner. At dessert, you suggest a little board game… and that’s when it all begins. Twenty minutes later, they know.',

  'how.etape1.titre': '“Shall we play a little game?”',
  'how.etape1.texte':
    'The box lands on the table. Everyone picks a side — team girl or team boy — and you ask the first of the eleven “mum or dad?” questions.',
  'how.etape1.alt':
    'What’s inside the Joyful Reveal game: the box, the question sheet and the two pouches',

  'how.etape2.titre': 'To answer, make some noise',
  'how.etape2.texte':
    'No raised hands: grab some children’s toys — rattles, squeaky toys — and make as much noise as possible. You decide which team gets to answer.',
  'how.etape2.alt': 'The two cotton pouches handed to the two teams',

  'how.etape3.titre': 'The noise builds and builds',
  'how.etape3.texte':
    'The team you didn’t pick makes twice as much noise on the next question. Then the other one. Every right answer wins a piece; by the eleventh, everyone builds the puzzle together.',
  'how.etape3.alt':
    'The Joyful Reveal puzzle assembled in its gold frame, the scratch piece still grey',

  'how.etape4.titre': 'The twelfth piece gets scratched',
  'how.etape4.texte':
    'One last question, a single winner. Silence, then the scream: the moment your loved ones will still be talking about years from now.',
  'how.etape4.alt': 'A hand scratches the last puzzle piece with a coin: the word GIRL appears',

  // Closing sentence split around the link: « <link> — rest ».
  'how.lienRegles': 'Read the full rules',
  'how.lienReglesSuite': '— questions included, ready to print.',

  // « Le secret des parents » — carte affichée sous le scénario (accueil,
  // fiche produit) et repliée sur la page des règles, que le QR code de la
  // boîte ouvre aussi pour les invités.
  'secret.label': '🤫 Parents only',
  'secret.titre': 'The parents’ secret',
  'secret.texte':
    'You are the only ones who know the questions in advance, and you choose which team answers. So you can, very discreetly, give luck a helping hand.',
  'secret.parrain':
    'Would you like to ask someone to be godfather or godmother? Give their team the floor whenever you know they have the answer. In the final, ask a question whose answer is a number you will have told them a few days before. It will be their hand that scratches the last piece.',
  'secret.chute': 'And the next question will be yours to ask.',
  'secret.afficher': '👀 Show the secret (parents only)',

  /* -------------------------------------------------------- GameDemo */

  'demo.badge': 'Try it now — a lightning round',
  'demo.titre': 'Play, just like on the big day',
  'demo.intro':
    'Two teams, eleven questions, a puzzle coming together. The twelfth piece gets scratched — and that is the one that tells all. Here is the game, in one minute.',

  // Announcements for screen readers (aria-live): each step of the demo.
  'demo.etape.pari': 'Step 1 of 4 — form your team',
  'demo.etape.questions': 'Step 2 of 4 — win the pieces',
  'demo.etape.cascade': 'Step 2 of 4 — the puzzle fills up',
  'demo.etape.subsidiaire': 'Step 3 of 4 — the tie-breaker question',
  'demo.etape.grattage': 'Step 4 of 4 — the big reveal',
  'demo.etape.final': 'Game over',
  'demo.aria.resultat': 'Result of the demo: it’s {mot}.',

  // The sex drawn at random, as it slots into the sentences: « It’s {mot}! »
  'demo.resultat.fille': 'a GIRL',
  'demo.resultat.garcon': 'a BOY',

  'demo.puzzle.aria': 'Demo puzzle: {n} piece(s) placed out of 12',
  'demo.puzzle.pieceAGratter': 'The scratch piece',
  'demo.puzzle.compteur': '🧩 {n}/12 pieces — the real puzzle artwork (14 × 21 cm)',

  'demo.pari.etiquette': 'Step 1 — just like in the rules: we form the teams',
  'demo.pari.titre': 'So, what does your gut say?',
  'demo.pari.fille': '💗 I bet on a GIRL',
  'demo.pari.garcon': '💙 I bet on a BOY',
  'demo.pari.note':
    'On the big day, everyone joins the team their instinct points to. Here the result is drawn at random — at home, it will be your real secret.',

  'demo.questions.etiquette': 'Question {numero} of 11 — taken from the real questionnaire',
  // Real questions from the questionnaire supplied in the box (original numbers).
  'demo.question.5': 'Who will sing the lullabies disastrously?',
  'demo.question.7': 'Who will cry at children’s films?',
  'demo.question.11':
    'Who might clumsily wake the baby by stepping on a noisy toy?',
  'demo.questions.maman': '🤱 Mum',
  'demo.questions.papa': '🧔 Dad',
  'demo.questions.gagne': '🧩 Piece won! It’s joining the puzzle…',
  'demo.questions.note':
    'In the real game, the parents-to-be have the final say — and you have to answer faster than the other team.',

  'demo.cascade.titre': '…and the other eight are won the same way.',
  'demo.cascade.texte':
    'Question after question, the puzzle fills up — for the demo, they are on us. Soon there will be just one piece left.',

  'demo.subsidiaire.etiquette':
    'One piece is missing — the tie-breaker question decides who scratches it',
  // The DEMO question — deliberately DIFFERENT from the game’s real tie-breaker,
  // so the home page never spoils the big-day surprise. That is why the demo
  // can give away the answer here.
  'demo.subsidiaire.question':
    'On average, how many hours a day does a newborn sleep?',
  'demo.subsidiaire.labelEstimation': 'Your guess at the number of hours',
  'demo.subsidiaire.placeholder': 'Your guess…',
  'demo.subsidiaire.valider': 'I’ll have a go!',
  // Feedback sentence, split around the <strong> (the guess that was typed in)
  // and the <sup> (the ordinal suffix of « 12th »).
  'demo.subsidiaire.retourAvant': 'Your guess:',
  'demo.subsidiaire.retourApres':
    '. The answer: around 16 to 17 hours a day! On the big day the question will be a different one — it’s printed in the rules, answer included 😉.',
  'demo.subsidiaire.retourPiece': 'Whoever comes closest wins the 12',
  'demo.subsidiaire.retourExposant': 'th',
  'demo.subsidiaire.retourFin': 'piece. Today, that honour is yours.',
  'demo.subsidiaire.cta': '🪙 Scratch the 12th piece',

  'demo.grattage.etiquette': 'The 12th piece is in your hands',
  // The two lines painted onto the silver layer (canvas).
  'demo.grattage.grattez': '✨ SCRATCH ✨',
  'demo.grattage.doigtOuSouris': 'finger or mouse',
  'demo.grattage.aria': 'The piece has been scratched: it’s {mot}.',
  'demo.grattage.revele': 'It’s {mot}! The piece is joining the puzzle…',
  'demo.grattage.revelerMaintenant': 'Reveal right away',
  'demo.grattage.revelerSansGratter': 'Reveal without scratching',

  'demo.final.titre': 'It’s {mot}!',
  'demo.final.pariGagne': 'And your team called it. Respect.',
  'demo.final.pariPerdu': 'The other team was right — it happens to the best of us.',
  // Sentence split around the <strong>: before / bold word / after.
  'demo.final.texteAvant': '…in this demo, at least. On the big day, it’s',
  'demo.final.texteFort': 'your',
  'demo.final.texteApres':
    'secret that your loved ones will discover — and the finished puzzle (14 × 21 cm, exactly frame-sized) stays on as a keepsake.',
  'demo.final.ctaBoutique': '🛒 I want this at home',
  'demo.final.rejouer': '↺ Play again',
};
